/* jshint camelcase: false */
(function (root, factory) {
    'use strict';
    if (typeof exports === 'object') {
        // CommonJS
        module.exports = factory();
    } else {
        // Global Variables
        root.UEM = root.UEM || {};
        root.UEM.shareData = factory();
    }
}(this, function () {

    var out = {};
    var NUM_SYSTEM = 36;
    var BIT_LENGTH = [ 24, 10, 1, 5, 13 ];
    var TOTAL_LENGTH = getBitStartIndex(5);
    var INT_MAX_LENGTH = 15;
    var SEPARATOR = '_';
    var SEPARATOR_SESS = '|';

    function numStringComplete(number, bit) {
        number = (!number || isNaN(number)) ? '' : number += '';
        if (number.length > bit) throw new Error('param length error ' + number + '.' + bit)
        while (number.length !== bit) number = '0' + number;
        return number;
    }

    function formatSdString(sd) {
        return (isString(sd.sessionid) ? '' : numStringComplete(sd.sessionid, BIT_LENGTH[0])) +
            numStringComplete(sd.deep, BIT_LENGTH[1]) +
            numStringComplete(sd.type, BIT_LENGTH[2]) +
            numStringComplete(sd.style, BIT_LENGTH[3]) +
            numStringComplete(+new Date(), BIT_LENGTH[4]);
    }

    out.encodeShareData = function(sd) {
        var result = '';
        if (isString(sd.sessionid)) {
            result += encodeSessionId(sd.sessionid) + SEPARATOR;
        }
        sd = formatSdString(sd);
        var round = Math.ceil(sd.length / INT_MAX_LENGTH);
        for (var i = 0; i < round; ++i) {
            var current = i * INT_MAX_LENGTH;
            result += parseInt((i === round - 1 ? '1' : '') + sd.slice(current, current + INT_MAX_LENGTH), 10).toString(NUM_SYSTEM) + SEPARATOR;
        }
        return result.slice(0, result.length - 1);
    }

    function getBitStartIndex(num) {
      var index = 0;
      for (var i = 0; i < num; ++i) index += BIT_LENGTH[i];
      return index;
    }

    function getBitStartIndexWithoutSd(num) {
      var index = 0;
      for (var i = 0; i < num; ++i) index += BIT_LENGTH[i + 1];
      return index;
    }

    function convert2Sd(sd, hasSessionId) {
        var resultObj = {};
        if (hasSessionId) {
            return {
                sessionid: sd.slice(getBitStartIndex(0), getBitStartIndex(1)),
                deep: parseInt(sd.slice(getBitStartIndex(1), getBitStartIndex(2)), 10),
                type: parseInt(sd.slice(getBitStartIndex(2), getBitStartIndex(3)), 10),
                style: parseInt(sd.slice(getBitStartIndex(3), getBitStartIndex(4)), 10),
                time: parseInt(sd.slice(getBitStartIndex(4), getBitStartIndex(5)), 10),
            };
        } else {
            return {
                deep: parseInt(sd.slice(getBitStartIndexWithoutSd(0), getBitStartIndexWithoutSd(1)), 10),
                type: parseInt(sd.slice(getBitStartIndexWithoutSd(1), getBitStartIndexWithoutSd(2)), 10),
                style: parseInt(sd.slice(getBitStartIndexWithoutSd(2), getBitStartIndexWithoutSd(3)), 10),
                time: parseInt(sd.slice(getBitStartIndexWithoutSd(3), getBitStartIndexWithoutSd(4)), 10),
            };
        }
    }

    function isString(sessionId) {
        return isNaN(sessionId) && typeof sessionId === 'string';
    }

    function encodeSessionId(sessionId) {
        // 转换成大写，使字母和‘-’的ASCII码都为2位10进制数字
        sessionId = sessionId.toUpperCase();
        var number = "";
        var length = sessionId.length;
        for (var i = 0; i < length; i++) {
            var item = sessionId.charCodeAt(i).toString(10);
            while (item.length !== 2) {
                item = '0' + item;
            }
            number += item;
        }
        var result = '', round = Math.ceil(number.length / INT_MAX_LENGTH);
        for (var i = 0; i < round; ++i) {
            var item = number.slice(i * INT_MAX_LENGTH, (i + 1) * INT_MAX_LENGTH);
            var temp = parseInt(item.slice(0, INT_MAX_LENGTH)).toString(NUM_SYSTEM);
            result += temp + SEPARATOR_SESS;
        }
        number = result.slice(0, result.length - 1);
        return number;
    }

    function decodeSessionId(string) {
        var result = '';
        string = string.split(SEPARATOR_SESS);
        for (var i = 0; i < string.length; ++i) {
            result += parseInt(string[i], NUM_SYSTEM);
        }
        var sessionId = "";
        var length = result.length;
        for (var i = 0; i < length;) {
            var code = result.slice(i, i += 2);
            sessionId += String.fromCharCode(parseInt(code, 10));
        }
        return sessionId.toLowerCase();
    }

    out.decodeShareData = function(sd) {
        var resultObj = {}, sessionId = '', result = '';
        sd = sd.split(SEPARATOR);
        for (var i = 0; i < sd.length; ++i) {
            if (sd[i].indexOf(SEPARATOR_SESS) !== -1) {
                sessionId = decodeSessionId(sd[i]);
            } else {
                result += i !== sd.length - 1 ? numStringComplete(parseInt(sd[i], NUM_SYSTEM), INT_MAX_LENGTH) : (parseInt(sd[i], NUM_SYSTEM) + '').slice(1);
            }
        }
        if (result.length === TOTAL_LENGTH) {
            resultObj = convert2Sd(result, true);
        } else if (result.length !== TOTAL_LENGTH && result.length === TOTAL_LENGTH - BIT_LENGTH[0]) {
            resultObj = convert2Sd(result, false);
        } else {
            throw new Error('__sd param parse error [error length]');
        }
        if (sessionId) resultObj.sessionid = sessionId;
        return resultObj;
    }

    return out;
}));
